import type { AccountType, ItemVerificationStatus, RecordKind } from '../types';

export const VERIFICATION_STATUS_LABEL: Record<ItemVerificationStatus, string> = {
  self_reported: 'Self-reported',
  evidence_supplied: 'Evidence supplied',
  manually_confirmed: 'Accepted by Employer',
  verified: 'Verified',
};

export const RECORD_KIND_LABEL: Record<RecordKind, string> = {
  qualification: 'Qualification',
  reference: 'Reference',
  work_experience: 'Work experience',
  official_document: 'Official document',
};

export const RECORD_KIND_PILL: Record<RecordKind, string> = {
  qualification: 'bg-violet-50 text-violet-800 border-violet-200',
  work_experience: 'bg-orange-50 text-orange-800 border-orange-200',
  reference: 'bg-rose-50 text-rose-800 border-rose-200',
  official_document: 'bg-teal-50 text-teal-800 border-teal-200',
};

export const RECORD_KIND_ACCENT: Record<RecordKind, string> = {
  qualification: 'border-l-violet-400',
  work_experience: 'border-l-orange-400',
  reference: 'border-l-rose-400',
  official_document: 'border-l-teal-400',
};

export function recordStatus(
  record?: { verification_status?: ItemVerificationStatus } | null,
): ItemVerificationStatus {
  return record?.verification_status ?? 'self_reported';
}

export function isAwaitingConfirmation(status?: ItemVerificationStatus): boolean {
  return !status || status === 'self_reported' || status === 'evidence_supplied';
}

export function isAtLeastConfirmed(status?: ItemVerificationStatus): boolean {
  return status === 'manually_confirmed' || status === 'verified';
}

export function isVerified(status?: ItemVerificationStatus): boolean {
  return status === 'verified';
}

export function homePath(accountType: AccountType): string {
  return accountType === 'verifier' ? '/verifier/queue' : '/dashboard';
}

export const PASSPORT_TAB_BY_KIND: Record<RecordKind, string> = {
  qualification: 'qualifications',
  work_experience: 'experience',
  reference: 'references',
  official_document: 'documents',
};

export function passportItemPath(
  profileId: string,
  kind: RecordKind,
  itemId: string,
  mode: 'verifier' | 'manager' = 'verifier',
): string {
  const base = mode === 'verifier' ? '/verifier/workers' : '/manager/workers';
  const tab = PASSPORT_TAB_BY_KIND[kind];
  return `${base}/${profileId}?tab=${tab}&item=${itemId}`;
}

export function passportItemAnchor(itemId: string): string {
  return `passport-item-${itemId}`;
}
